"use strict";
/*
 * This file is part of the Wrzasq.pl.
 *
 * @copyright 2019, 2024 - 2025 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
class Modal {
    constructor(modalBox, content) {
        this.modalBox = modalBox;
        this.content = content;
    }
    display() {
        this.modalBox.display(this.content);
    }
    bind(trigger) {
        trigger.addEventListener("click", () => {
            this.display();
        });
    }
}
exports.Modal = Modal;
